import React from 'react'
import {CreditHolidayRuleTable} from 'components/table/credit_holiday_rule/CreditHolidayRuleTable'

const CreditHolidayRule = () => {
    return (
        <>
            <CreditHolidayRuleTable/>
        </>
    )
}

export { CreditHolidayRule }